import { Field } from "../hooks/api/karl-farm/useFields";

export const getFieldLabel = (field: Field) => {
  const main_id = field.custom_attributes?.app_properties?.main_id;
  const Marknr = field.custom_attributes?.properties?.Marknr;
  const id = field.id;
  return main_id || Marknr || id;
};
